/**
 * BarraDeProgreso — cuánto llevas.
 *
 * El acento naranja SÍ pinta aquí: el reparto del 2026-09-03 se lo reservó para
 * el ítem activo de la barra lateral, **las barras de progreso** y la puerta de
 * la pantalla pública. Lo que no pinta es un botón.
 *
 * `role="progressbar"` con sus tres valores: sin eso, un lector de pantalla lee
 * un `div` vacío y el porcentaje se queda solo en el texto de al lado, que no
 * siempre está.
 *
 * Subió de `features/inicio/piezas.tsx` el 2026-09-08: la usan el avance de un
 * curso en Inicio y la tasa de lectura de un comunicado en Novedades, y una
 * feature no importa de otra.
 */
export function BarraDeProgreso({ pct, etiqueta }: { pct: number; etiqueta: string }) {
  const valor = Math.max(0, Math.min(100, Math.round(pct)));
  return (
    <div
      className="h-2 overflow-hidden rounded-full bg-sunken"
      role="progressbar"
      aria-valuenow={valor}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={etiqueta}
    >
      {/* Se anima el ancho porque es LO QUE EL DATO ES, no un adorno: la barra
          no tiene otra forma de existir. No hay transición declarada, así que
          tampoco hay ningún fotograma que el navegador tenga que recalcular. */}
      <div className="h-full rounded-full bg-accent" style={{ width: `${valor}%` }} />
    </div>
  );
}
